import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { BrandKit } from "../models/BrandKit";
import { db } from "../services/Firebase";

/** Keep asset processing status current while the composer is open. */
export function useWorkspaceBrandKits(workspaceId: string | null | undefined) {
  const [state, setState] = useState<{
    workspaceId?: string;
    kits: BrandKit[];
    loaded: boolean;
    synced: boolean;
  }>({ kits: [], loaded: false, synced: false });

  useEffect(() => {
    if (!workspaceId) return;
    let active = true;
    const unsubscribe = onSnapshot(
      query(collection(db, "brand_kits"), where("userId", "==", workspaceId)),
      (snapshot) => {
        if (!active) return;
        setState({
          workspaceId,
          kits: snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }) as BrandKit),
          loaded: true,
          synced: !snapshot.metadata.fromCache,
        });
      },
      (error) => {
        if (!active) return;
        console.error("Error watching brand kits:", error);
        setState({ workspaceId, kits: [], loaded: true, synced: false });
      },
    );
    return () => {
      active = false;
      unsubscribe();
    };
  }, [workspaceId]);

  // `synced` means the list came from the server, so a kit missing from it is
  // really gone rather than not loaded yet or unreadable.
  return state.workspaceId === workspaceId && workspaceId
    ? { kits: state.kits, loaded: state.loaded, synced: state.synced }
    : { kits: [], loaded: false, synced: false };
}
